var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "bet-arrow-sl",
  "use": "bet-arrow-sl-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bet-arrow-sl\">\n    <path d=\"M8.171 1.071h-3.35a.536.536 0 0 1-.53-.463L4.286.536c0-.271.201-.496.463-.531L4.82 0h4.643A.534.534 0 0 1 10 .536v4.643a.536.536 0 0 1-1.067.072L8.93 5.18v-3.35L.915 9.843a.536.536 0 0 1-.81-.697l.052-.06L8.17 1.07z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id